var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewCurve',{attrs:{"dataCurve":_vm.curve_data}})}
var staticRenderFns = []

export { render, staticRenderFns }